// 10025 专用身份存储，不覆盖基座的 token、appId 和 user_info。
export const UNIFIED_AUTH_KEY = 'cmhub_unified_auth';

export const clearUnifiedAuth = () => localStorage.removeItem(UNIFIED_AUTH_KEY);

export const normalizeUnifiedAuth = (data) => {
  if (!data || !['FULL', 'PARTIAL'].includes(data.status)
    || !['public', 'private'].includes(data.customerAuthMode)) {
    throw new Error('统一登录返回的状态或认证模式无效');
  }
  const identities = {};
  ['customer', 'merchant'].forEach((side) => {
    const identity = data[side];
    if (identity && identity.available === true) {
      const required = ['token', 'appId', 'accountId', 'userId', 'tenantId'];
      if (required.some((key) => typeof identity[key] !== 'string' || !identity[key])) {
        throw new Error('统一登录返回的身份信息不完整，ID 必须为字符串');
      }
      identities[side] = { ...identity };
    } else {
      // 不缓存不可用侧可能携带的旧 token。
      identities[side] = {
        available: false,
        errorCode: identity && identity.errorCode,
        message: identity && identity.message,
      };
    }
  });
  const availableCount = Object.values(identities).filter((item) => item.available).length;
  if (availableCount !== (data.status === 'FULL' ? 2 : 1)) {
    throw new Error('统一登录状态与可用身份不一致');
  }
  return { status: data.status, customerAuthMode: data.customerAuthMode, ...identities };
};

export const saveUnifiedAuth = (data) => {
  // 校验失败也不能继续沿用上一次登录的客商身份。
  clearUnifiedAuth();
  const auth = normalizeUnifiedAuth(data);
  localStorage.setItem(UNIFIED_AUTH_KEY, JSON.stringify(auth));
  return auth;
};

export const getUnifiedAuth = () => {
  try {
    const stored = localStorage.getItem(UNIFIED_AUTH_KEY);
    return stored ? normalizeUnifiedAuth(JSON.parse(stored)) : null;
  } catch (error) {
    clearUnifiedAuth();
    return null;
  }
};
